/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_GithubInputs */

const en_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ar_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const bn_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const de_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const es_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const fr_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pt_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const zh_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const tr_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const ru_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

const pl_resume_github = /** @type {(inputs: Resume_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

/**
* | output |
* | --- |
* | "GitHub" |
*
* @param {Resume_GithubInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_github = /** @type {((inputs?: Resume_GithubInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_GithubInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_github(inputs)
	if (locale === "bn") return bn_resume_github(inputs)
	if (locale === "de") return de_resume_github(inputs)
	if (locale === "es") return es_resume_github(inputs)
	if (locale === "fr") return fr_resume_github(inputs)
	if (locale === "pt") return pt_resume_github(inputs)
	if (locale === "zh") return zh_resume_github(inputs)
	if (locale === "tr") return tr_resume_github(inputs)
	if (locale === "ru") return ru_resume_github(inputs)
	if (locale === "pl") return pl_resume_github(inputs)
	return en_resume_github(inputs)
});